module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMS4wNzgiIGhlaWdodD0iMTQuNzczIiB2aWV3Qm94PSIwIDAgMTEuMDc4IDE0Ljc3MyI+PHBhdGggZD0iTTguNDQ5IDEyLjQ3OUwyLjYzNSA3LjM5MW01LjgwOC01LjA5NmwtNS44MTYgNS4wOSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNUY4MDhDIiBzdHJva2Utd2lkdGg9IjEuNDQ0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./public/img/headerIcons/arrow-blue.svg
// module id = 103
// module chunks = 0